import { Typography } from '@mui/material'

export default function StepHeader({ children }) {
    return <Typography variant="h6" component="h3">{children}</Typography>
}
